import {
  Input,
  InputGroup,
  InputLeftElement,
  type InputProps,
  InputRightElement,
} from "@chakra-ui/react"
import { type ReactNode, forwardRef } from "react"

import { SearchIcon } from "@/components/Icons"

type Props = InputProps & {
  // Shown at the right end of the field (e.g. a clear button).
  rightElement?: ReactNode
}

// Compact search field (40px, ADR 0001 Q7 / Q15): list toolbars use the sm control height.
export const SearchbarInput = forwardRef<HTMLInputElement, Props>(
  ({ rightElement, ...inputProps }, ref) => (
    <InputGroup size="sm">
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="textSubtle" boxSize="4" />
      </InputLeftElement>
      <Input
        pl="9"
        pr={rightElement ? "9" : undefined}
        size="sm"
        variant="searchbar"
        {...inputProps}
        ref={ref}
      />
      {rightElement && <InputRightElement>{rightElement}</InputRightElement>}
    </InputGroup>
  )
)

SearchbarInput.displayName = "SearchbarInput"
